<table class="mvd_table--notes" *ngIf="!editMode">
    <tbody>
        <tr [ngClass]="{'tr--oig-fraud' : note.isOIGFraud,'tr--confidential': note.isConfidential}">
            <td>
                <a href="javascript:void(0);" title="Confidential" *ngIf="note.isConfidential"><i class="material-icons">lock</i></a>
                <a class="icon--nay" href="javascript:void(0);" title="OIG Fraud" *ngIf="note.isOIGFraud"></a>
                {{note.noteDescription}}
            </td>
            <td class="w--cust-name">{{note.businessUnit}}</td>
            <td class="w--date-time">{{note.updatedDate | date:'M/d/yyyy'}} {{note.updatedDate | date:'shortTime'}}</td>
            <td class="w--cust-name">{{note.updatedBy}}</td>
            <td class="w--actions-3">
                <ng-container *ngIf="!isReadonly">
                    <ng-container *ngIf="!isAddOnly">
                        <a class="icon--history" href="javascript:void(0);" title="View History" (click)="popupNotesHistory(note)"></a>
                        <a class="icon--edit" href="javascript:void(0);" title="Edit" *ngIf="(note.isOIGFraud && isOIGBU) || !note.isOIGFraud" (click)="toggleEditMode()"></a>
                        <a class="icon--delete" href="javascript:void(0);" *ngIf="!isDeleteDisabled && (((note.isOIGFraud && isOIGBU) || (note.businessUnitId == 6 && isMedicalReviewBU)) || (!note.isOIGFraud && note.businessUnitId != 6))" title="Delete" (click)="deleteNote()"></a>
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </tbody>
</table>

<note-entry [(note)]="editNote" (noteSaved)="onNoteSaved($event)" (noteCancelled)="onEditCancelled()" *ngIf="editMode"></note-entry>
